import React from "react";
import { Typography, Grid, Divider } from "@material-ui/core";
import ReactPlayer from "react-player";

export default props => (
  <div>
    <Typography variant="h5" color="primary" component="h2">
      Schematic
    </Typography>
    <div style={{ textAlign: "center" }}>
      <img
        style={{ borderRadius: "8px", border: "1px solid gray" }}
        src="./Schematic2.jpg"
        alt="Schematic"
        width="50%"
      />
    </div>
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      What does it do?
    </Typography>
    <p>
      This device can used to maintains desired temperature and acidity for
      efficient fermentation of Curd/Yogurt and Batter of Indian breakfasts
      (Idli, Dosa etc).
    </p>
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      Who's done what beforehand?
    </Typography>
    <br />
    <Grid container alignItems="center" spacing={16}>
      <Grid item xs>
        <div align="center" className="player-wrapper">
          <ReactPlayer
            url="https://www.youtube.com/watch?v=r4bYyc8Q_pw"
            width="100%"
            height="100%"
            controls
          />
        </div>
      </Grid>
      <Grid item xs>
        <div align="center" className="player-wrapper">
          <ReactPlayer
            width="100%"
            height="100%"
            url="https://www.youtube.com/watch?v=v63mDRILNss"
            controls
          />
        </div>
      </Grid>
      <Grid item xs>
        <div align="center" className="player-wrapper">
          <ReactPlayer
            width="100%"
            height="100%"
            url="https://www.youtube.com/watch?v=LU98cUcoW64"
            controls
          />
        </div>
      </Grid>
    </Grid>
    <br />
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      Who will use it ?
    </Typography>
    <p>
      There are not any low cost Fermentation solution available for small
      families. This product can fill that gap.
    </p>
  </div>
);
